module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-89.ddff6cff.svg";